import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Form from './form.page'
import FormHelper from '../../../utils/FormHelper'
import Worker from './worker'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import { ScrollIntoViewById } from '../../../utils/UIHelper'
import iconLogo from '../../../assets/images/logo.png'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import '../common.styles.scss'

class Forgot extends React.Component {

    constructor(props) {
        super(props)
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    componentDidMount() {
        document.title = "Forgot Password"
        ScrollIntoViewById("root")
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.onReset()
    }

    onReset = () => {
        this.worker.isValid() && this.setState({
            ...this.state,
            processing: true,
            showError: false
        }, () => this.worker.reset())
    }

    render() {
        console.log('forgot')
        return (
            <>
                {this.state.tab === 0 && <div className="login">
                    {this.state.processing && <Dialog><Loading /></Dialog>}
                    <header>
                        <img alt="" src={iconLogo} />
                        <h1>Reset your password</h1>
                        <p>Please enter your email address.</p>
                    </header>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <Form onSubmit={this.onSubmit} onChange={FormHelper(this).onChange} onRememberMeChange={this.onRememberMeChange} {...this.state} />
                    <div className="login-action">
                        Already have an account?
                        <Link to="/auth/login">Log In</Link>
                    </div>
                </div>}

                {this.state.tab === 1 && <div className="register">
                    <header>
                        <img alt="" src={iconLogo} />
                        <h1>Reset Instructions</h1>
                        <p>If we find your account, we’ll send you a reset link.</p>
                    </header>
                </div>}

            </>

        )
    }
}

export default connect(null)(withRouter(Forgot))